import script from "./PatientVariableDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientVariableDialog.vue?vue&type=script&setup=true&lang=js"

import "./PatientVariableDialog.vue?vue&type=style&index=0&id=4544fe4a&scoped=true&lang=css"
import "./PatientVariableDialog.vue?vue&type=style&index=1&id=4544fe4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4544fe4a"]])

export default __exports__